<template>
  <div class="new-assignment">
    <div v-if="!nextSelected">
      <div class="form-fields">
        <div class="input-field">
          {{ $t('assignment.labels.contractorDetails') }}
        </div>
        <div class="input-field">
          {{ $t('assignment.labels.clientDetails') }}
        </div>
        <div class="input-field">
          Branch
        </div>
      </div>
      <div class="form-fields">
        <div class="input-field">
          <InputField
            v-if="contractorNameSelected"
            v-model="selectedContractorName"
            type="text"
            class="bordered"
            name="Contractor"
            picker="minus-circle"
            readonly
          />
          <tol-type-ahead
            v-else
            :search-params="{
              url: '/assignments/user-quick-search',
              searchKeys: ['username', 'users.first_name', 'users.last_name', 'users.email'],
              objectType: 'contractor'
            }"
            class="bordered"
            menu-label="Search Contractor"
            @select-item="onSelectContractor($event)"
          >
            <template v-slot="{ value }">
              {{ value.last_name }}, {{ value.first_name }}
            </template>
          </tol-type-ahead>
        </div>

        <div class="input-field">
          <InputField
            v-if="clientNameSelected"
            v-model="selectedClientName"
            type="text"
            class="bordered"
            name="Client"
            picker="minus-circle"
            readonly
            @picker-click="onRemoveSelectedClient()"
          />

          <tol-type-ahead
            v-else
            :search-params="{
              url: '/assignments/user-quick-search',
              searchKeys: ['name'],
              objectType: 'client'
            }"
            class="bordered"
            menu-label="Search Client"
            @select-item="onSelectClient($event)"
          >
            <template v-slot="{ value }">
              {{ value.name }}
            </template>
          </tol-type-ahead>
        </div>
        <div class="input-field">
          <DropdownSelect
            :menu-items="branchNames"
            menu-label="Select Branch"
            :selected-item="newAssignment.branch_name"
            class="bordered"
            @select-item="onSelectBranch($event)"
          />
        </div>
        <div v-show="areMandatoryFieldsSelected" class="next" @click="nextSelected = true">
          Next
        </div>
      </div>
    </div>
    <div v-else>
      <AssignmentDetailsForm :assignment="newAssignment" />
    </div>
  </div>
</template>

<script>
import AssignmentDetailsForm from '../assignment-details/components/AssignmentDetailsForm';
import { AppActions } from '@/app/app.keys';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import DropdownSelect from '@/app/components/DropdownSelect';
import InputField from '@/app/components/InputField';
import { NewAssignmentActions, NewAssignmentGetters } from './new-assignment.keys';
import { AppGetters } from '@/app/app.keys';
import { newAssignmentService } from './new-assignment.service';

export default {
  components: {
    AssignmentDetailsForm,
    TolTypeAhead,
    DropdownSelect,
    InputField
  },
  data() {
    return {
      selectedContractorName: 'Select Contractor Name',
      selectedClientName: 'Select Client Name',
      selectedBranchName: 'Select Branch',
      nextSelected: false,
      contractorSearchEnabled: true
    };
  },

  computed: {
    newAssignment() {
      return this.$store.getters[NewAssignmentGetters.NewAssignment];
    },
    areMandatoryFieldsSelected() {
      return (
        this.newAssignment.contractor_id &&
        this.newAssignment.client_id &&
        this.newAssignment.branch_name
      );
    },
    branchNames() {
      return this.$store.getters[AppGetters.BranchNames];
    },
    contractorNameSelected() {
      return this.selectedContractorName !== 'Select Contractor Name';
    },
    clientNameSelected() {
      return this.selectedClientName !== 'Select Client Name';
    }
  },
  async mounted() {
    this.$store.dispatch(
      AppActions.SetPageTitle,
      this.$t('assignments.listing.newAssignment.title')
    );
    if (this.$route.query.contractor_refNum) {
      let contractRefNum = this.$route.query.contractor_refNum;
      let newSearchContractor = await newAssignmentService.retrieveSelectedContractor(
        contractRefNum
      );
      this.onSelectContractor(newSearchContractor[0]);
      this.contractorSearchEnabled = false;
    }
  },
  destroyed() {
    this.$store.dispatch(NewAssignmentActions.SetNewAssignment);
  },
  methods: {
    onSelectContractor(event) {
      this.$store.dispatch(NewAssignmentActions.SetAssignmentContractor, event);
      this.selectedContractorName = event.display_name;
    },
    onSelectClient(event) {
      this.$store.dispatch(NewAssignmentActions.SetAssignmentClient, event);
      this.selectedClientName = event.name;
    },
    onSelectBranch(event) {
      this.$store.dispatch(NewAssignmentActions.SetAssignmentBranch, event);
      this.selectedBranchName = event;
    },
    onRemoveSelectedClient() {
      this.$store.dispatch(NewAssignmentActions.ResetAssignmentClient);
      this.selectedClientName = 'Select Client Name';
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.new-assignment {
  padding: 60px;
  background-color: $white;

  .form-fields {
    margin-top: 50px;
    display: flex;
    .input-field {
      flex-basis: 350px;
      margin-right: 20px;
      font-weight: bold;
    }

    .next {
      padding: 6px 25px;
      background-color: $secondary-green;
      color: $white;
      font-weight: bold;
      margin-left: 30px;
      cursor: pointer;
      &:hover {
        background-color: $green;
      }
    }
  }
}
</style>
